/**
 * Image
 */

import StringUtil from './StringUtil';

class Image {
  /**
   * @param {string} content - markup template string
   * @return {string} markup template string
   */
  static replaceUploadImage( content ) {
    const reg = /(&lt;img src=.+plaync\.co.+\/file\/.+&gt;+)/;
    const exec = reg.exec( content );
    let c = ``;
    let rep = ``;

    if ( exec && exec.length ) {
      c = exec[ 0 ];
      rep = StringUtil.decodeAll( c );
      return content.replace( c, rep );
    }

    return content;
  }
}

export default Image;
